import Customise from './components/Dimension';
import Details from './components/Details';
import Download from './components/Download';

import reducers from './reducers';
import routes from './routes';

import datasetReducer from './reducers'
export { datasetReducer }

export default {
    Customise,
    Details,
    Download,
    reducers,
    routes
}


// WEBPACK FOOTER //
// ./pages/dataset/index.js